export const ExternalConfig = {
    // fb app config: waba API
    FB_APP_ID: '544831322621153',
    FB_APP_CONFIG_ID: '729289425345483',
    GOOGLE_MAP_API_KEY: 'AIzaSyBFSe1I3bLn0WE-Ub3pFazrErMWZaugJo8',
    SHOP_APP_BASE_URL: window.peasyConfig.shopURL
}

export const WP_PERSONAL_EVENTS = {
    // ON_QR_REFRESH:"ON_WA_QR_REFRESH",
    ON_QR_SCANED:"ON_WA_QR_SCANED",
}

export const TWILIO_CALL_ROUTES = [
    {
        id: 'human',
        name:"Human"
    },
    {
        id: 'ai_agent',
        name:"AI Agent"
    },
]
export const TWILIO_CALL_RING_DURATIONS = [
    {
        id: 10,
        name:"10 sec"
    },
    {
        id: 15,
        name:"15 sec"
    },
    {
        id: 20,
        name:"20 sec"
    },
    {
        id: 25,
        name:"25 sec"
    },
    {
        id: 30,
        name:"30 sec"
    },
    {
        id: 35,
        name:"35 sec"
    },
    {
        id: 40,
        name:"40 sec"
    },
]
export const CONCURRENCY_CALL_LIMITS = [
    {
        id: 3,
        name:"3"
    },
    {
        id: 4,
        name:"4"
    },
    {
        id: 5,
        name:"5"
    },
    {
        id: 6,
        name:"6"
    },
    {
        id: 7,
        name:"7"
    },
    {
        id: 8,
        name:"8"
    },
    {
        id: 9,
        name:"9"
    },
    {
        id: 10,
        name:"10"
    },
]